// extracted by mini-css-extract-plugin
export default {"root":"phase-header-rates_root__TA+1b","rate":"phase-header-rates_rate__3kcEx","discount":"phase-header-rates_discount__jhae-"};